import React from "react";
import { Carousel } from "@trendyol-js/react-carousel";

const rightArrow = <div className="btn">{">"}</div>;
const leftArrow = <div className="btn">{"<"}</div>;

const TabBar = ({ models, onClick }) => {
  const width = window.innerWidth;

  const show = width / 320 - 1.5;

  return (
    <div className="header">
      <div className="title">Garage728</div>

      <Carousel
        responsive
        show={show}
        className="carousel"
        rightArrow={rightArrow}
        leftArrow={leftArrow}
      >
        {models.map((model) => (
          <div className="card" onClick={() => onClick(model)}>
            {model.title}
          </div>
        ))}
      </Carousel>
    </div>
  );

 
};

export default TabBar;
